var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9697 4.46967C11.2626 4.17678 11.7374 4.17678 12.0303 4.46967L19.0303 11.4697C19.3232 11.7626 19.3232 12.2374 19.0303 12.5303L12.0303 19.5303C11.7374 19.8232 11.2626 19.8232 10.9697 19.5303C10.6768 19.2374 10.6768 18.7626 10.9697 18.4697L16.6893 12.75H5.5C5.08579 12.75 4.75 12.4142 4.75 12C4.75 11.5858 5.08579 11.25 5.5 11.25H16.6893L10.9697 5.53033C10.6768 5.23744 10.6768 4.76256 10.9697 4.46967Z",
    fill: "white",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight24Line);
export default __webpack_public_path__ + "static/media/Arrow-Right-24-line.7fa97e13e71f778d4c981e89b70488cd.svg";
export { ForwardRef as ReactComponent };